import { Text, Tooltip } from '@driftt/dds'
import React, { useMemo } from 'react'
import ReactDOMServer from 'react-dom/server'

import AISparklesIcon from 'components/AISparklesIcon'

interface AICondition {
  name: string
  enabled: boolean
}

interface AISparklesTooltipProps {
  conditions: AICondition[]
}

export const AISparklesTooltip: React.FC<AISparklesTooltipProps> = ({
  conditions,
}) => {
  const AI_TOOLTIP_LABELS: Record<string, string> = {
    aiEnabled: 'AI Topics',
    isGPTEnabled: 'AI Responses skill',
  }

  const aiText = useMemo(
    () =>
      conditions
        .reduce((current: string[], condition: AICondition) => {
          if (condition.enabled) {
            current.push(AI_TOOLTIP_LABELS[condition.name])
          }
          return current
        }, [])
        .join(' & '),
    [conditions, AI_TOOLTIP_LABELS]
  )
  return (
    <Tooltip
      side="top"
      align="center"
      content={
        <Text
          variant="metadata"
          dangerouslySetInnerHTML={{
            __html: ReactDOMServer.renderToStaticMarkup(
              <span>
                Powered by <b>{aiText}</b>
              </span>
            ),
          }}
        />
      }
    >
      <AISparklesIcon />
    </Tooltip>
  )
}
